import React from "react";
import { useController } from "react-hook-form";
import { ToggleButtonSet, ToggleButtonSetLegend, ToggleButton, ToggleButtonListStateless } from "@visa/vds";

function MCSControlToggle(props) {
  const { field } = useController(props);
  const handleChange = (e) => {
    if (props.readOnly) return
    if (props.handleChange) {
      props.handleChange(e);
    } else {
      field.onChange(parseInt(e.target.value));
    }
  };
  return (
    <ToggleButtonSet name={props.name} className={props.readOnly ? "mcs-control-toggle-disabled" : ""}>
      <ToggleButtonSetLegend style={{ fontSize: "12px" }}>{props.label}</ToggleButtonSetLegend>
      <ToggleButtonListStateless >
        {
          props.buttons.map((item, idx) =>
            <ToggleButton
              name={item.name}
              checked={field.value == item.value}
              id={item.id}
              label={item.label}
              value={item.value}
              onChange={handleChange}
              onFocus={() => { }}
            />
          )
        }
      </ToggleButtonListStateless>
    </ToggleButtonSet>
  );
}

export default MCSControlToggle;
